import {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";

import { db } from "config/firebaseConfig";
import { query } from "firebase/database";
import { collection, getDocs } from "firebase/firestore";

const GlobalContext = createContext();
export const GlobalContextProvider = ({ children }) => {
  let date = new Date();
  const [rangedData, setRangedData] = useState([]);
  const [dateRange, setDateRange] = useState([
    new Date(date.getFullYear(), date.getMonth(), 1),
    new Date(date.getFullYear(), date.getMonth() + 1, 0),
  ]);
  const [startDate, endDate] = dateRange;
  const [loading, setLoading] = useState(true);
  const [fullSearch, setFullSearch] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [incidentsTypes, setIncidentsTypes] = useState([]);
  const [categories, setCategories] = useState([]);
  const [locations, setLocations] = useState([]);

  const getIncidentsTypes = useCallback(async () => {
    let types = [];
    const q = query(collection(db, "incidentsTypes"));
    const data = await getDocs(q);
    data.forEach((doc) => {
      let type = doc.data();
      type.id = doc.id;
      types.push(type);
    });
    types.sort((a, b) => a.name.localeCompare(b.name));
    setIncidentsTypes(types);
  }, []);

  const getCategories = useCallback(async () => {
    let types = [];
    const q = query(collection(db, "incidentsCategories"));
    const data = await getDocs(q);
    data.forEach((doc) => {
      let type = doc.data();
      type.id = doc.id;
      types.push(type);
    });
    types.sort((a, b) => a.name.localeCompare(b.name));
    setCategories(types);
  }, []);

  const getLocations = useCallback(async () => {
    let types = [];
    const q = query(collection(db, "incidentsLocations"));
    const data = await getDocs(q);
    data.forEach((doc) => {
      let type = doc.data();
      type.id = doc.id;
      types.push(type);
    });
    types.sort((a, b) => a.name.localeCompare(b.name));
    setLocations(types);
  }, []);

  useEffect(() => {
    getIncidentsTypes();
    getCategories();
    getLocations();
  }, [getCategories, getLocations, getIncidentsTypes]);

  return (
    <GlobalContext.Provider
      value={{
        rangedData,
        setDateRange,
        dateRange,
        setRangedData,
        startDate,
        endDate,
        loading,
        setLoading,
        fullSearch,
        setFullSearch,
        searchText,
        setSearchText,
        incidentsTypes,
        categories,
        locations,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
export const useStore = () => useContext(GlobalContext);
export default GlobalContextProvider;
